
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 43 49"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.875.75L31 7.875l-9.5 9.5 4.75 4.75 9.5-9.5 7.125 7.125v-19z"}}),_c('path',{attrs:{"d":"M.125 3.106A2.364 2.364 0 012.498.75h16.627V5.5H4.875v38h33.25v-19h4.75v21.358a2.376 2.376 0 01-2.358 2.392H2.483a2.375 2.375 0 01-2.358-2.356V3.106z"}})])
          )
        }
      }
    